import React from 'react';
import st from './styles.module.scss';
import { ApiSelect, TextType } from "@baseTypes/baseType";
import { VehiclesStatusesState } from "../../../store/reducers/dashboard/vehicles/statuses/types";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { identity } from "fp-ts/es6/function";
import { stickerLoadingWithCrop } from "../phases";
import { useTypedSelector } from "@hooks/useTypedSelector";
import { isEmpty } from "lodash";
import Empty from './empty';
import Sticker from "@elements/sticker/Sticker";
import Tx from "@baseTypes/naming";
import { formatNumber2d } from "@utils/format/number";
import StickerHeader from "@elements/sticker/StickerHeader";
import Container from "@elements/container/Container";
import VehiclesStatusesChart from "@pages/dashboard/vehiclesStatuses/chart";

const selector: ApiSelect<VehiclesStatusesState> = createSelector(
	(state: RootState) => state.vehiclesStatuses,
	identity<VehiclesStatusesState>
)

const VehiclesStatuses = () => {
	const { data } = useTypedSelector(state => state.vehiclesStatuses)

	const renderBody = () => {
		return (
			<>
				<StickerHeader
					isLink={false}
					hintText={'Статусы техники отображаются по умолчанию на текущий момент'}
					textType={TextType.Header}
					title={Tx.VehicleStatuses}
					rightPlacement={() => `${formatNumber2d(data.count)} ед.`}
				/>
				<Container>
					<VehiclesStatusesChart statuses={data.byStatus} />
				</Container>
			</>
		)
	}

	return (
		<Sticker className={st['sticker']}>
			{data.count && !isEmpty(data.byStatus) ? renderBody() : <Empty/>}
		</Sticker>
	)
}

export default stickerLoadingWithCrop(selector, () => () => ([]), { cropEnabled: false })(VehiclesStatuses)